import React, { useState } from 'react';
import WMSHeader from './WMSHeader';
import Sidebar from './Sidebar';
import ManufacturingDashboard from './ManufacturingDashboard';
import KitAssembly from './KitAssembly';
import ComponentInventory from './ComponentInventory';
import BatchTraceability from './BatchTraceability';
import OrderManagement from './OrderManagement';
import UserManagement from './UserManagement';
import BarcodeIntegration from './BarcodeIntegration';
import Reports from './Reports';

const WMSApp = ({ currentUser, onLogout }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <ManufacturingDashboard currentUser={currentUser} />;
      case 'kit-assembly':
        return <KitAssembly currentUser={currentUser} />;
      case 'component-inventory':
        return <ComponentInventory currentUser={currentUser} />;
      case 'batch-traceability':
        return <BatchTraceability currentUser={currentUser} />;
      case 'barcode-integration':
        return <BarcodeIntegration currentUser={currentUser} />;
      case 'orders':
        return <OrderManagement currentUser={currentUser} />;
      case 'users':
        return currentUser?.permissions?.includes('all') ? (
          <UserManagement currentUser={currentUser} />
        ) : (
          <div className="p-4 lg:p-6">
            <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">Access Denied</h1>
            <p className="text-gray-600 mt-2">You don't have permission to access user management.</p>
          </div>
        );
      case 'receiving':
        return <div className="p-4 lg:p-6"><h1 className="text-2xl lg:text-3xl font-bold text-gray-900">Component Receiving</h1><p className="text-gray-600 mt-2">Receive components and Naloxone base kits</p></div>;
      case 'shipping':
        return <div className="p-4 lg:p-6"><h1 className="text-2xl lg:text-3xl font-bold text-gray-900">Kit Shipping</h1><p className="text-gray-600 mt-2">Ship completed Naloxone kits to customers</p></div>;
      case 'quality':
        return <div className="p-4 lg:p-6"><h1 className="text-2xl lg:text-3xl font-bold text-gray-900">Quality Control</h1><p className="text-gray-600 mt-2">Quality assurance and Health Canada compliance checks</p></div>;
      case 'reports':
        return <Reports currentUser={currentUser} />;
      case 'settings':
        return <div className="p-4 lg:p-6"><h1 className="text-2xl lg:text-3xl font-bold text-gray-900">System Settings</h1><p className="text-gray-600 mt-2">Configure manufacturing processes and compliance settings</p></div>;
      default:
        return <ManufacturingDashboard currentUser={currentUser} />;
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <WMSHeader 
        currentUser={currentUser} 
        onLogout={onLogout} 
        onMenuToggle={handleMenuToggle}
      />
      
      <Sidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        currentUser={currentUser}
        isOpen={sidebarOpen}
        onClose={handleSidebarClose}
      />
      
      <main style={{
        marginLeft: '0px',
        paddingTop: '120px'
      }} className="lg:ml-72">
        <div style={{ minHeight: '100vh' }}>
          {renderContent()}
        </div>
      </main>
    </div>
  );
};

export default WMSApp;